import styled from "styled-components";
import { TABLET_BP } from "@website-builder/utilities/constants/style-constants/screen-sizes.js";

export const ImportantDateCardWrapper = styled.div`
	padding: 80px 0;
	.right-container .date-section {
		display: flex;
		justify-content: flex-start;
		margin-bottom: 24px;
	}
	.card-container {
		padding: 40px 48px;
	}
	.inner-grid-container {
		margin: 0;
	}
	.date-container {
		padding-left: 24px;
		border-left: ${({ isDarkBg }) =>
			isDarkBg
				? `1px solid var(--secondary-gray-medium)`
				: `1px solid rgba(5, 8, 43, 0.3)`};
		border-bottom: none;
		height: min-content;
		padding-right: 32px;
		&.last-container {
			padding-right: 0px;
		}
	}
	.title,
	.description {
		margin-bottom: 16px;
	}

	@media only screen and (max-width: ${TABLET_BP}px) {
		padding: 40px 0;
		.right-container {
			& .date-section {
				flex-direction: column;
				justify-content: center;
			}
			& button {
				width: 100%;
			}
		}
		.left-container {
			grid-row-gap: 0;
		}
		.card-container {
			padding: 40px 24px;
		}
		.date-container {
			border-top: 1px solid rgba(5, 8, 43, 0.3);
			border-left: none;
			padding: 16px 0;
		}
	}
`;
